<template>
  <div class="under-link-desc">
    <p class="content font-size-14">起飞推广相关的框下链接包含<span class="c-007CFF">邀约链接（框下）</span>、<span
        class="c-007CFF">基础框下链接</span>和<span
        class="c-007CFF">附加框下链接</span>三类。<br/>若推广稿件框下已设置邀约链接，系统将直接优化该邀约链接的点击；若稿件框下未设置邀约链接，则需要在起飞投放端设置附加框下链接（必须设置）和基础框下链接（非必须设置）。
      三种框下链接的区别参见下表：
    </p>
    <Table class="table kic-table mt-16" border size="small" :columns="columns" :data="tableData"
           :span-method="handleSpan">
      <template slot-scope="{ row }" slot="title">
        <p class="font-weight-600 c-333">{{ row.title }}</p>
      </template>
      <template slot-scope="{ row }" slot="priority">
        <p v-for="(item, index) in row.priority" :key="index" :class="{'pb-32': index === 0}">{{ item }}</p>
      </template>
      <template slot-scope="{ row }" slot="type">
        <p v-html="row.type"></p>
      </template>
      <template slot-scope="{ row }" slot="required">
        <p v-html="row.required"></p>
      </template>
      <template slot-scope="{ row }" slot="link_offline">
        <p v-html="row.link_offline"></p>
      </template>
    </Table>
  </div>
</template>
<script>
export default {
  data () {
    return {
      columns: [
        {
          title: ' ',
          slot: 'title'
        },
        {
          title: '展现场景',
          key: 'scene'
        },
        {
          title: '优先级',
          slot: 'priority'
        },
        {
          title: '设置方式',
          key: 'type'
        },
        {
          title: '是否必须',
          key: 'required'
        },
        {
          title: '链接下线',
          slot: 'link_offline'
        }
      ],
      tableData: [{
        title: '邀约框下链接',
        scene: '自然流量场景和起飞投放场景',
        priority: ['自然流量场景：邀约链接>基础框下链接', '起飞投放场景：邀约链接>附加框下链接'],
        type: '花火官网',
        required: '非必须',
        link_offline: '邀约框下链接失效时下线'
      }, {
        title: '附加框下链接',
        scene: '起飞投放场景',
        priority: ['自然流量场景：邀约链接>基础框下链接', '起飞投放场景：邀约链接>附加框下链接'],
        type: '起飞投放端->推广管理->新建/编辑创意',
        required: '无邀约框下链接时必须设置',
        link_offline: '对应创意下线时下线；<br />单元/计划暂停时下线；<br />账户余额不足时下线'
      }, {
        title: '基础框下链接',
        scene: '自然流量场景',
        priority: ['自然流量场景：邀约链接>基础框下链接', '起飞投放场景：邀约链接>附加框下链接'],
        type: '起飞投放端->账户管理->基础框下链接',
        required: '非必须',
        link_offline: '计划暂停时下线；<br />对应计划无在投附加框下链接时下线；'
      }]
    }
  },
  methods: {
    handleSpan ({
      row,
      column,
      rowIndex,
      columnIndex
    }) {
      if (rowIndex === 0 && columnIndex === 2) {
        return {
          rowspan: 3,
          colspan: 1
        }
      }
      if (rowIndex >= 1 && columnIndex === 2) {
        return {
          rowspan: 0,
          colspan: 0
        }
      }
    }
  }
}
</script>
<style lang="less">
.under-link-desc {
  .content {
    line-height: 1.8;
  }

  .table {
    &.ivu-table-wrapper .ivu-table.ivu-table-small {
      font-size: 14px;
    }

    .ivu-table-header table tr th {
      border-bottom-color: #F8FAFB;
      border-right-color: #F8FAFB;
    }

    .ivu-table-body .ivu-table-row td:first-child {
      background-color: #F8FAFB;
      border-bottom-color: #F8FAFB;
    }

    .ivu-table-body .ivu-table-row:first-child td:nth-child(3) {
      border-bottom-color: #F8FAFB;
    }
    .ivu-table-body .ivu-table-row:last-child td {
      border-bottom-color: #F8FAFB;
    }

    .ivu-table-cell {
      padding: 10px;
    }
  }
}
</style>
